export default __webpack_public_path__ + "8b353bc7724228799b2ac6facc143ab2.png";